// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3u6jR","remove":"File_remove__3URA0"};